module.exports = __webpack_public_path__ + "img/footerlogo.adbc380.png";